import React, { useEffect, useState } from 'react';
import { getDocumentsFirebase } from '../../services/data-firebase';
import SvgArrowL from '../svg/SvgArrowL';
import SvgArrowR from '../svg/SvgArrowR';
import SvgLoading from '../svg/SvgLoading';
import AnimatedSection from '../../tools/AnimatedSection';

const DetailBusiness = ({ createUserClients, createUserProfesional }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [urlSliderFirebase, setUrlSliderFirebase] = useState([]);

  // Obtener las URLs de Firebase
  useEffect(() => {
    const getUrlSlider = async () => {
      const collectionName = "url-slider";
      try {
        const dataUrl = await getDocumentsFirebase(collectionName);
        setUrlSliderFirebase(dataUrl);
      } catch (error) {
        console.error(error);
      }
    };

    getUrlSlider();
  }, []);

  // Navegación del slider
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % urlSliderFirebase.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? urlSliderFirebase.length - 1 : prevIndex - 1
    );
  };

  // Cambiar automáticamente las imágenes cada 2.5 segundos
  useEffect(() => {
    const interval = setInterval(nextImage, 2500);
    return () => clearInterval(interval);
     // eslint-disable-next-line
  }, [urlSliderFirebase]); // Dependencia para reiniciar el intervalo si las URLs cambian

  return (
    <div className="max-w-7xl mx-auto sm:px-2 lg:px-12 text-center py-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Texto */}
      <AnimatedSection delay={0.3} >
        <div className="order-2 md:order-1">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Conectamos <span className="text-blue-500">Niñeras</span> y{' '}
            <span className="text-green-500">Padres</span> de forma sencilla
          </h1>
          <p className="text-gray-600 text-lg md:text-xl max-w-xl mx-auto mb-8 leading-relaxed">
            Encuentra la niñera ideal para tus hijos o comienza tu carrera como niñera. Todo en un solo lugar.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <a
              onClick={createUserProfesional}
              href="#register-nanny"
              className="bg-blue-500 text-white py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              Registrarme como Niñera
            </a>
            <a
              onClick={createUserClients}
              href="#register-mother"
              className="bg-green-500 text-white py-3 px-8 rounded-full shadow-lg hover:bg-green-600 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              Registrarse como Padres
            </a>
          </div>
        </div>
      </AnimatedSection>

        {/* Slider de imágenes */}
      <AnimatedSection delay={0.8} >
        <div className="order-1 md:order-2 relative">
          <div className="relative w-full h-96 md:h-[70vh] overflow-hidden rounded-lg shadow-xl">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
            >
              {urlSliderFirebase.length > 0 ? (
                urlSliderFirebase.map((image, index) => (
                  <img
                    key={index}
                    src={image.url} // Usa la URL de Firebase
                    alt={`Imagen ${index + 1}`}
                    className="w-full h-full object-cover flex-shrink-0"
                  />
                ))
              ) : (
                <div className="flex items-center justify-center w-full h-full">
                  <SvgLoading />
                </div>
              )}
            </div>
          </div>
          {/* Botones de navegación */}
          <button
            onClick={prevImage}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 rounded-full p-2 shadow-md hover:bg-opacity-100 transition-all"
          >
            <SvgArrowL />
          </button>
          <button
            onClick={nextImage}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 rounded-full p-2 shadow-md hover:bg-opacity-100 transition-all"
          >
            <SvgArrowR />
          </button>
        </div>
      </AnimatedSection>
      </div>

      {/* Texto adicional */}
      <AnimatedSection   delay={0.3} >

      <p className="text-gray-500 text-sm md:text-base max-w-3xl mx-auto mt-12 leading-relaxed">
        Desde 2018, en Niñeras Ya nos dedicamos a guiar, acompañar y asesorar en la búsqueda de niñeras capacitadas, confiables y responsables para el cuidado de tus hijos.
      </p>
      </AnimatedSection>

    </div>
  );
};

export default DetailBusiness;